import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuotationDetailsComponent } from './components/quotation-details/quotation-details.component'
import { AddressDetailsComponent } from './components/address-details/address-details.component'
import { LineItemsComponent } from './components/line-items/line-items.component'
import { ReviewComplianceQuestionComponent } from './components/review-compliance-question/review-compliance-question.component'
import { ReviewNotificationAttachmentsComponent } from './components/review-notification-attachments/review-notification-attachments.component'
import { QuoteReviewComponent } from './components/quote-review/quote-review.component'
import { QuoteCartModule } from '../quote-cart/quote-cart.module'
import { SpinnerModule } from '@spartacus/storefront'
import { RouterModule } from '@angular/router'
import { ConfigModule, I18nModule, UrlModule } from '@spartacus/core'
import { MatTooltipModule } from '@angular/material/tooltip'
import { environment } from '../../../../environments/environment'

@NgModule({
  declarations: [
    QuotationDetailsComponent,
    AddressDetailsComponent,
    LineItemsComponent,
    ReviewComplianceQuestionComponent,
    ReviewNotificationAttachmentsComponent,
    QuoteReviewComponent,
  ],
  imports: [
    CommonModule,
    QuoteCartModule,
    SpinnerModule,
    UrlModule,
    RouterModule,
    I18nModule,
    MatTooltipModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['quoteReview'],
        },
      },
    }),
  ],
})
export class QuoteReviewModule {}
